require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-twelve-java-resources-for-the-modern-developer.json") })
        }
      }, "path---blog-twelve-java-resources-for-the-modern-developer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-twelve-java-resources-for-the-modern-developer!./.cache/json/blog-twelve-java-resources-for-the-modern-developer.json
// module id = 1122
// module chunks = 231608221292675